export function findByType(entries, type) {
    return entries.find((entry) => entry.type === type);
}
